import React, { useEffect, useState } from "react";
import NavHeader from "../components/NavHeader";
import {
  Button,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { CourseTema } from "../const/types";
import cr from "../lib/request";
import ComponentSpinner from "../components/ComponentSpinner";
import useTrigger from "../globalState/useTrigger";
import { Link } from "react-router-dom";
import { ArrowRight, MagnifyingGlass } from "@phosphor-icons/react";
import { iconSize } from "../const/sizes";
import TableContainer from "../components/TableContainer";
import formatDate from "../lib/formatDate";
import UpdateCourseTemaModal from "../components/courseComponents/UpdateCourseTemaModal";
import DeleteCourseTemaModal from "../components/courseComponents/DeleteCourseTemaModal";
import NoOflinesText from "../components/NoOflinesText";
import TambahCourseTemaModal from "../components/courseComponents/TambahCourseTemaModal";
import NoData from "../components/NoData";

export default function CourseTemaPage() {
  const [data, setData] = useState<CourseTema[] | null>(null);
  const [search, setSearch] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const { trigger } = useTrigger();

  useEffect(() => {
    setLoading(true);
    const url = `api/course/theme/alltheme`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [trigger]);

  return (
    <>
      <NavHeader label="Tema Course" backLink={"/course"} />

      <HStack justify={"space-between"} p={5}>
        <InputGroup>
          <InputLeftElement>
            <Icon as={MagnifyingGlass} />
          </InputLeftElement>
          <Input
            placeholder="Pencarian"
            maxW={"400px"}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            value={search}
          />
        </InputGroup>

        <HStack>
          <TambahCourseTemaModal />

          <Button
            colorScheme="ap"
            variant={"outline"}
            as={Link}
            to={"/course/tema/restore"}
            rightIcon={<Icon as={ArrowRight} fontSize={iconSize} />}
          >
            Restore
          </Button>
        </HStack>
      </HStack>

      {!loading && data && data.length > 0 ? (
        <VStack align={"stretch"}>
          <TableContainer>
            <Table>
              <Thead>
                <Tr>
                  <Th pl={5}>#</Th>
                  {/* <Th>ID</Th> */}
                  <Th>Nama</Th>
                  <Th>Deskripsi</Th>
                  <Th>Dibuat</Th>
                  <Th pr={5} textAlign={"center"} w={"100px"}>
                    Aksi
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {data.map((kategori, i) => {
                  const ok =
                    kategori.theme_name
                      .toLowerCase()
                      .includes(search.toLowerCase()) ||
                    kategori.description
                      .toLowerCase()
                      .includes(search.toLowerCase()) ||
                    kategori.id.toString().includes(search);

                  return (
                    ok && (
                      <Tr
                        key={i}
                        _hover={{ bg: "var(--divider)" }}
                        transition={"200ms"}
                      >
                        <Td pl={5} opacity={0.5}>
                          {i + 1}
                        </Td>
                        {/* <Td>{kategori.id}</Td> */}
                        <Td>{kategori.theme_name}</Td>
                        <Td>
                          <NoOflinesText w={"300px"}>
                            {kategori.description}
                          </NoOflinesText>
                        </Td>
                        <Td whiteSpace={"nowrap"}>
                          {formatDate(kategori.created_at)}
                        </Td>
                        <Td pr={5}>
                          <HStack>
                            <DeleteCourseTemaModal data={kategori} />
                            <UpdateCourseTemaModal data={kategori} />
                          </HStack>
                        </Td>
                      </Tr>
                    )
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </VStack>
      ) : !loading && data && data.length === 0 ? (
        <NoData />
      ) : (
        <ComponentSpinner flex={1} />
      )}
    </>
  );
}
